export default __webpack_public_path__ + "static/media/IBMPlexSans-Medium.03402514.ttf";